/** Fetch the per-place bundle (weather + news + article) from our backend. */
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useLocalBundle(place) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!place?.lat || !place?.lon) {
      setData(null);
      return;
    }
    let alive = true;
    setLoading(true);
    axios
      .get(`${API}/geo/local`, {
        params: {
          lat: place.lat,
          lon: place.lon,
          name: place.city || "",
          region: place.region || "",
          country: place.country || "",
          country_code: place.country_code || undefined,
        },
      })
      .then(({ data }) => alive && setData(data))
      .catch(() => alive && setData(null))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [place?.lat, place?.lon, place?.city, place?.region, place?.country, place?.country_code]);

  return { data, loading };
}
